import { ClassicCard } from "@braze/web-sdk";
import { getInitializedBrazeClient } from "./braze-client";
import { prepareUserObjectForAnalytics } from "utils/users-utils";
import { User } from "shared/datamodel/schemas";

export function initBrazeUser(userId: string, user: User) {
  const brazeClient = getInitializedBrazeClient();
  if (!brazeClient) return;

  brazeClient.changeUser(userId);
  brazeClient.getUser()?.setEmail(user.email);
  brazeClient.getUser()?.setFirstName(user.name);

  const flattenedUserProperties = prepareUserObjectForAnalytics(user);

  for (const [key, value] of Object.entries(flattenedUserProperties)) {
    brazeClient.getUser()?.setCustomUserAttribute(key, value);
  }
  brazeClient.logCustomEvent("user_logged_in");
  brazeClient.openSession();
}

export function trackEvent(event: string, props: Record<string, unknown>) {
  const brazeClient = getInitializedBrazeClient();
  if (!brazeClient) return;

  brazeClient.logCustomEvent(event, props);
}

export function logCardDismissal(contentCard?: ClassicCard) {
  const brazeClient = getInitializedBrazeClient();

  if (contentCard) {
    brazeClient?.logCardDismissal(contentCard);
  }
}
